<header class="h-[60px]">
  <nav class="flex h-full w-full items-center justify-between gap-4 bg-pl-black pl-4">
    <div class="flex h-full items-center gap-6">
      <pl-burger-menu-button
        *ngIf="!hideMenu"
        (click)="onMenuButtonCLick()"
        [isMenuOpen]="isMenuOpen"
      ></pl-burger-menu-button>

      <a
        class="flex h-full cursor-pointer items-center gap-4 py-2 text-white"
        [ngClass]="{ 'pointer-events-none': disableLinkOnPlLogo }"
        (click)="onPlLogoClick($event)"
      >
        <img src="assets/pl_logo_and_text_white.svg" alt="logo potentialife" class="h-full" />
      </a>
    </div>

    <pl-release-stage-display [whiteText]="true" />

    <pl-menu-button-profile *ngIf="!hideProfileSection" class="h-full" />
  </nav>
</header>
